import { render, staticRenderFns } from "./TenantReadinessCheck.vue?vue&type=template&id=3148f4ea&"
import script from "./TenantReadinessCheck.vue?vue&type=script&lang=js&"
export * from "./TenantReadinessCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports